/******************************************************************************************
 *	Customer Mini-profile popup
 *******************************************************************************************/
(function() {
  

  angular
    .module('rcDirectives.customerMiniProfile', [])

    //Returns the bounding client rect object from the .customer-list element.
    //Needed to determine the position the mini-profile popover will hold: either over or under the parent element of the popover.
    //Data is cached, however you can force a new query to the DOM by setting forceGetFromDOM to be true.
    .service('customerListBoundingRect', function() {
      var cachedData;

      this.get = function(forceGetFromDOM) {
        if (!cachedData || forceGetFromDOM) {
          cachedData = document.querySelector('.data-list').getBoundingClientRect();
        }
        return cachedData;
      };
    })
    .directive(
      'rcCustomerMiniProfile',
      /* @ngInject */
      function(
        $document,
        $animate,
        customerListBoundingRect,
        DomUtility,
        feature,
        ResellerPlanTypes
      ) {
        return {
          restrict: 'A',
          templateUrl: 'templates/customer-mini-profile.html',
          transclude: true,
          link: function(scope, element) {

            //DOM Elements
            var triggerLink = angular.element(element[0].querySelector('.js-link-parent a'));
            var popover = angular.element(element[0].querySelector('.popover'));

            //Show / Hide popover
            var visible = false;
            var showPopover = function() {
              visible = true;

              //Remove the under-element class if it's present.
              //Otherwise it would cause the mini-profile to never show above after it was first shown below.
              //It must also be removed before measurement as the top value for a popover positioned below that
              //is higher than the one of the customers list element would incorrectly position the popover
              //above which could mean it's cut-off visually.
              popover.removeClass('under-element');

              //Measure popover top position to know if it goes over or under the trigger link
              //Set display to block so the bounding rect can be computed
              popover.addClass('before-measurement');

              //If the top of the popover is over the top of the customers list, position the element under its parent
              var popoverTop = popover[0].getBoundingClientRect().top;
              if (popoverTop <= customerListBoundingRect.get().top) {
                popover.addClass('under-element');
              }

              //We're done measuring
              popover.removeClass('before-measurement');

              //Animate in
              popover.addClass('visible');
            };
            var hidePopover = function() {
              visible = false;
              popover.removeClass('visible');
            };

            //Show popover after clicking the trigger link
            var triggerLinkClickHandler = function(event) {
              event.preventDefault();

              if (!visible) {
                showPopover();

                //Hide mini-profile if click occurs outside `element` or ESC key is pressed
                $document.on('keydown', keydownHandler);
                $document.on('click', documentClickHandler);
              }
            };
            triggerLink.on('click', triggerLinkClickHandler);

            //Hide popover if visible and click occurs outside `element` or on Edit Details link (if shown).
            var documentClickHandler = function(event) {
              if (!visible) {
                return;
              }

              var wasEditDetailsClicked = function(target) {
                var editDetails = element[0].querySelector('.edit-details');
                return editDetails === target;
              };

              //If the event.target is a child of the current directive `element`, with the exception
              //of the edit details link, don't hide the the popover for this element. The
              //popover should be hidden when the Edit Customer modal is shown.
              if (
                !DomUtility.isDescendant(event.target, element[0]) ||
                wasEditDetailsClicked(event.target)
              ) {
                hidePopover();

                //Remove the listener, will be re-added if click occurs on triggerLink
                removeDocumentListeners();
              }
            };

            //Hide popover if ESC key is pressed
            var keydownHandler = function(event) {
              var keyCode = DomUtility.getKeyCode(event);

              if (visible && keyCode === 27) {
                //Esc key
                hidePopover();

                //Remove the listener, will be re-added if click occurs on triggerLink
                removeDocumentListeners();
              }
            };

            //Clear document click and keypress listeners
            var removeDocumentListeners = function() {
              $document.off('keydown', keydownHandler);
              $document.off('click', documentClickHandler);
            };

            //Clean-up
            scope.$on('$destroy', function() {
              triggerLink.off('click', triggerLinkClickHandler);
              removeDocumentListeners();
            });

            // planType is an array
            scope.getResellerPlanTypeString = function(planType) {
              return ResellerPlanTypes.getResellerPlanTypeString(planType);
            };
          }
        };
      }
    );
})();
